// Importing required modules from the 'three' library and custom components
import * as THREE from 'three';

import Camera from './components/Camera';
import EventDispatcher from './common/EventDispatcher';
import AssetLoader from './components/AssetLoader';
import GameScene from './components/GameScene';
import { Global } from './common/global';
import GameControl from './components/GameControl';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { Server } from './common/callServer';
import $ from 'jquery';
import './styles/game.scss';
import './styles/main.scss';
import './styles/fonts.scss';
import './styles/anim.scss';

import { isMobile, isMobileOnly } from 'mobile-device-detect';

import Sounds from './components/Sounds';

import gsap from 'gsap';
import Lights from './components/Lights';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import Control from './components/Control';
import Player from './components/Player';
import Car from './components/Car';
import LanguageSelection from './components/LanguageSelection';
import StartScreen from './components/StartScreen';
import FormScreen from './components/FormScreen';
import UploadScreen from './components/UploadScreen';
import CharacterScreen from './components/CharacterScreen';
import InstructionScreen from './components/InstructionScreen';
import ScroreScreen from './components/ScroreScreen';

let lastTime = 0;
let fps = 0;
let frameCount = 0;
let lastDeltaVec = new THREE.Vector3();

const TARGET_FPS = 60;
const TARGET_FRAME_INTERVAL = 1000 / TARGET_FPS; // ~16.667 ms
let lastRenderTime = 0; // Tracks the last successful render time (in ms)

export default class Game extends THREE.Scene {
  environmentMap = null;
  sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  constructor() {
    super();
    window.addEventListener('resize', this.onResize.bind(this));
  }
  init() {
    Global.carInspectIndex = 0;
    document.querySelector('#soundBtn').addEventListener('click', () => {
      Global.soundEnabled = !Global.soundEnabled;

      if (Global.soundEnabled) {
        (document.querySelector('#BGAudio').volume = 0.2),
          document.querySelector('#BGAudio').play();
        document.querySelector('#soundBtn').classList.add('active');
      } else {
        document.querySelector('#BGAudio').pause();
        document.querySelector('#soundBtn').classList.remove('active');
      }
      Global.soundEnabled && document.querySelector('#tapAudio').play();
    });
    this.lastRendered = false;
    this.canRender = true;
    lastTime = 0;
    fps = 0;
    frameCount = 0;
    // this.stats = new Stats();
    // this.stats.showPanel(0);
    // document.body.appendChild(this.stats.dom);
    this.assetsLoaded = false;
    Global.gameTry = 1;
    Global.userRegistered = false;
    Global.controlType = null;
    this.fixedTimeStep = 1 / 60; // Fixed time step for physics (60 FPS)
    this.accumulator = 0; // Accumulated time since the last physics step

    Global.serverObj = new Server();
    this.createUser();
    this.physicsTimeScale = isMobile ? 0.95 : 1;
    this.gameTime = 0;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('PLAYER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('USER_EVENTS', this.onEvents.bind(this));

    this.canvas = document.querySelector('canvas.webgl');
    this.clock = new THREE.Clock();

    this.camera = new Camera(
      isMobile ? 75 : 50,
      this.sizes.width / this.sizes.height,
      0.1,
      isMobile ? 300 : 500
    );

    // this.ui = new UI();
    // this.ui.init();

    // this.gameSounds = new Sounds(this, this.camera);
    // this.gameSounds.init();

    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      precision: 'highp',
      powerPreference: 'high-performance',
    });
    this.camera.init(this.renderer);
    this.add(this.camera);

    this.camera.position.set(36.5, 16, -30);

    this.createLevel();
    this.createUI();

    // this.controls = new Control(this.camera, this.renderer.domElement);
    // this.controls.enableDamping = true;
    // this.controls.dampingFactor = 0.05;
    // this.controls.rotateSpeed = -0.8;
    // this.controls.enabled = true;
    // this.controls.minDistance = 1; // Minimum distance the camera can zoom in
    // this.controls.maxDistance = 330; // Maximum distance the camera can zoom out

    // this.controls.target.set(0, -3, 5);

    this.renderer.physicallyCorrectLights = true;
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.toneMappingExposure = 0;
    this.renderer.useLegacyLights = false;
    this.renderer.setClearColor(0x000000, 0);
    this.renderer.toneMapping = THREE.NoToneMapping;
    // this.renderer.toneMappingExposure = 1.1;
    this.renderer.gammaFactor = 2.2;
    this.renderer.gammaOutput = false;
    this.renderer.outputColorSpace = THREE.SRGBColorSpace;
    this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.renderer.setSize(this.sizes.width * 1, this.sizes.height * 1);
    this.renderer.setPixelRatio(
      Math.min(Math.max(1, window.devicePixelRatio), isMobile ? 1.75 : 2.5)
    );

    Global.maxAniso = this.renderer.capabilities.getMaxAnisotropy();
    Global.maxAniso = Math.min(8, Global.maxAniso);

    this.assetLoader = new AssetLoader(this);
    this.assetLoader.init();

    this.onResize();
    this.tick();

    const rgbeLoader = new RGBELoader();
    rgbeLoader.load(
      './textures/environmentMaps/1/cannon_1k.hdr',
      (environmentMap) => {
        environmentMap.mapping = THREE.EquirectangularReflectionMapping;
        Global.envMap = environmentMap;

        this.assetLoader.prepare();
      }
    );
    rgbeLoader.load('./textures/environmentMaps/1/bg.hdr', (environmentMap) => {
      environmentMap.mapping = THREE.EquirectangularReflectionMapping;
      Global.envMap2 = environmentMap;
    });
    // this.assetLoader.prepare();
  }
  createUser() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const utm_source = urlParams.get('utm_source');
    Global.utm_source = utm_source;
    $.ajax({
      url: `${Global.BASE_URL}createUser.php`,
      method: 'POST',
      dataType: 'json',
      data: {
        saveType: 'create',
        utm_source,
      },
      success(responseData) {
        if (responseData.status === 200) {
          Global.U_ID = responseData.UID;
          Global.gameKey = responseData.gamekey;
        }
      },
      error(jqXHR, textStatus, errorThrown) {
        console.error('createUser AJAX error:', textStatus, errorThrown, jqXHR);
      },
    });
  }
  createLevel() {
    Global.cars = [];

    this.gameScene = new GameScene(this, this.camera);
    this.gameScene.init();

    this.player = new Player(this, this.camera);
    this.player.init();

    this.lights = new Lights(this, this.camera, this.renderer);
    this.lights.init();

    this.gameControl = new GameControl(this);
    this.gameControl.init();

    let carIndex = 1;
    for (let i = 60; i <= 60 + Global.carsTotal; i++) {
      this[`car${i}`] = new Car(
        this,
        i,
        Math.floor(Math.random() * 9 + 1),
        carIndex++
      );
      this[`car${i}`].init();
    }

    // this.startGame();
  }
  createUI() {
    this.LanguageSelection = new LanguageSelection(this);
    this.LanguageSelection.init();

    this.StartScreen = new StartScreen(this);
    this.StartScreen.init();

    this.FormScreen = new FormScreen(this);
    this.FormScreen.init();

    this.UploadScreen = new UploadScreen(this);
    this.UploadScreen.init();

    this.CharacterScreen = new CharacterScreen(this);
    this.CharacterScreen.init();

    this.InstructionScreen = new InstructionScreen(this);
    this.InstructionScreen.init();

    this.ScroreScreen = new ScroreScreen(this);
    this.ScroreScreen.init();
  }
  stopGame() {
    Global.isGameActive = false;
    Global.serverObj.send(
      `${Global.BASE_URL}webservice.php`,
      (response) => {
        document.querySelector('#game_header').classList.remove('active');
        document.querySelector('#joystick-zone').classList.remove('active');
        this.events.dispatchEvent({
          type: 'GAMESCENE_EVENTS',
          message: {
            event_type: 'disappear_pringles',
            data: {},
          },
        });
        this.events.dispatchEvent({
          type: 'GAMESCENE_EVENTS',
          message: {
            event_type: 'disable_player',
            data: {},
          },
        });
        gsap.delayedCall(1.0, () => {
          this.events.dispatchEvent({
            type: 'GAMESCENE_EVENTS',
            message: {
              event_type: 'dispose',
              data: {},
            },
          });

          // Global.soundEnabled && document.querySelector('#BGAudio').pause();
          this.hideGameView();
          // document.querySelector('#game_view').classList.remove('active');
          this.events.dispatchEvent({
            type: 'GAMESCENE_EVENTS',
            message: {
              event_type: 'show_screen',
              data: {
                screenKey: 'ScoreScreen',
              },
            },
          });
        });
      },
      null,
      {
        saveType: 'saveScore',
        score: Global.pringlesCollected,
        name: Global.name,
        email: Global.email,
        mobile: Global.mobile,
        utm_source: Global.utm_source,
        country: Global.country,
        gameTry: Global.gameTry,
        uniqID: Global.U_ID,
      },
      'POST',
      null,
      false
    );
  }
  startGame() {
    // var canvas = document.querySelector('canvas');
    // var videoStream = canvas.captureStream(24);
    // var mediaRecorder = new MediaRecorder(videoStream);
    // var chunks = [];
    // mediaRecorder.ondataavailable = function (e) {
    //   chunks.push(e.data);
    // };

    // mediaRecorder.onstop = function (e) {
    //   blob = new Blob(chunks, { type: 'video/mp4' });
    //   this._blob = blob;
    //   chunks = [];
    //   var videoURL = URL.createObjectURL(blob);

    //   video.src = videoURL;
    //   video.play();
    //   document.querySelector('#videoDiv').style.display = 'block';
    // };
    // mediaRecorder.ondataavailable = function (e) {
    //   chunks.push(e.data);
    // };

    // mediaRecorder.start();
    // setTimeout(function () {
    //   mediaRecorder.stop();
    // }, 10000);

    document.querySelector('#game_header').classList.add('active');
    Global.isGameActive = true;
    const timerObject = { time: 45 };
    this.lastTime = 45;
    document.querySelector('#game_header .timer_sec .label').innerHTML =
      this.lastTime;
    this.gameTimer = gsap.to(timerObject, {
      time: 0, // Target value
      duration: 45,
      delay: 1,
      ease: 'linear', // Consistent speed
      onUpdate: () => {
        this.currentTime = Math.round(timerObject.time);
        if (this.lastTime != this.currentTime) {
          document.querySelector(
            '#game_header .timer_sec .label'
          ).innerHTML = `${this.currentTime < 10 ? '0' : ''}${
            this.currentTime
          }`;
        }
        this.lastTime = Math.round(timerObject.time);
      },
      onComplete: () => {
        this.events.dispatchEvent({
          type: 'GAMESCENE_EVENTS',
          message: {
            event_type: 'game_over',
            data: {},
          },
        });
        document.querySelector('#game_header .timer_sec .label').innerHTML =
          '00';
      },
    });
  }
  hideAllScreen() {}

  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'load_complete':
        if (this.assetsLoaded) return;

        // Global.gender = 'Male';
        this.assetsLoaded = true;
        document.querySelector('#soundBtn').classList.add('active2');
        document.querySelector('#splash_scr').classList.remove('active');
        this.setUpGame();
        break;
      case 'replay_game':
        this.replayGame(false);
        break;
      case 'show_game_view':
        this.showGameView();
        break;
      case 'init_scene':
        // this.showScene();
        // this.startGameTimer();
        // this.setupFreekick();
        break;
      case 'start_game':
        this.startGame();
        // this.setupFreekick();
        break;
      case 'game_over':
        this.stopGame(true);

        break;
      // case 'changeScreen':
      //   this.changeScreen(data['message']['data']['nextScreen']);
      //   break;
    }
  }

  replayGame() {
    Global.carInspectIndex = 0;
    Global.cars = [];
    Global.pringles = [];
    Global.pringlesSet = 0;
    Global.pringlesCollected = 0;
    Global.pringlesToCollide = [];
    Global.roadMeshes = [];

    document.querySelector('#game_header .timer_sec .label').innerHTML = '45';
    document.querySelector('#game_header .score_sec .label').innerHTML = '00';
    document.querySelector('#game_view').classList.add('active');

    this.createLevel();

    this.gameTry++;
    gsap.delayedCall(0.25, () => {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'create_scene',
          data: {},
        },
      });
      this.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'add_player',
          data: {},
        },
      });
      this.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'add_pin',
          data: {},
        },
      });
      gsap.delayedCall(0.1, () => {
        this.events.dispatchEvent({
          type: 'CAMERA_EVENTS',
          message: {
            event_type: 'update_replay_pos',
            data: {},
          },
        });
      });
    });

    gsap.delayedCall(0.5, () => {
      // document.querySelector('#BGAudio').volume = 0.1;
      // document.querySelector('#BGAudio').currentTime = 0;
      // Global.soundEnabled && document.querySelector('#BGAudio').play();
      document.querySelector('#soundBtn').classList.remove('active2');
      this.showGameView();
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'start_game',
          data: {},
        },
      });
    });
  }
  hideGameView() {
    document.querySelector('#game_view .cover').classList.remove('disabled');
    document.querySelector('.main').classList.remove('disabled');

    document.querySelector('#chips1').classList.remove('disabled');
    document.querySelector('#chips2').classList.remove('disabled');
    document.querySelector('#chips3').classList.remove('disabled');
    document.querySelector('#soundBtn').classList.add('active2');
  }
  showGameView() {
    document.querySelector('#game_view .cover').classList.add('disabled');
    document.querySelector('.main').classList.add('disabled');

    document.querySelector('#chips1').classList.add('disabled');
    document.querySelector('#chips2').classList.add('disabled');
    document.querySelector('#chips3').classList.add('disabled');
  }
  changeScreen(nextScreen) {
    document
      .querySelectorAll('.screen')
      .forEach((el) => (el.style.display = 'none'));
    document.getElementById(nextScreen).style.display = 'flex';
  }
  startGameTimer() {
    if (Global.introShown) {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'Game',
          },
        },
      });

      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'start_time',
          data: {},
        },
      });
    }
    // document.querySelector('.game_header').classList.add('active');
  }
  stopTimer() {
    this.gameTimer && clearInterval(this.gameTimer);
  }
  updateTime() {
    this.gameTime += 100;
    let totalSeconds = Math.floor(this.gameTime / 1000); // Convert to total seconds
    let minutes = Math.floor(totalSeconds / 60); // Calculate total minutes
    let seconds = totalSeconds % 60; // Calculate remaining seconds

    document.querySelector('#info_time .txt').innerHTML = `${
      minutes < 10 ? '0' : ''
    }${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  setUpGame() {
    for (let i = 1; i <= 10; i++) {
      Global.assets['textures'][`product_${i}`]['asset'].encoding =
        THREE.sRGBEncoding;
      Global.assets['textures'][`product_${i}`]['asset'].colorSpace =
        THREE.SRGBColorSpace;
    }
    this.environment = Global.envMap;
    // this.environmentRotation = Math.PI / 2;
    // this.background = Global.envMap;
    // this.backgroundIntensity = 1;
    // this.backgroundBlurriness = 2;

    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'create_scene',
        data: {},
      },
    });
    this.events.dispatchEvent({
      type: 'SOUND_EVENTS',
      message: {
        event_type: 'init_sounds',
        data: {},
      },
    });

    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'Language',
        },
      },
    });
    return;

    this.showGameView();
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'add_player',
        data: {},
      },
    });
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'add_pin',
        data: {
          imgUrl: null,
        },
      },
    });

    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'Instructions',
        },
      },
    });
  }

  // Event handler for window resize
  onResize() {
    // Update sizes
    this.sizes.width = window.innerWidth; /* isMobile
      ? window.innerWidth
      : 0.56 * window.innerHeight; */
    this.sizes.height = window.innerHeight;

    // Dispatching events to update camera and renderer sizes
    this.events.dispatchEvent({
      type: 'CAMERA_EVENTS',
      message: {
        event_type: 'resize',
        data: {
          aspect: this.sizes.width / this.sizes.height,
          sizes: this.sizes,
        },
      },
    });
    if (
      (window.innerWidth <= window.innerHeight && isMobile) ||
      (window.innerWidth >= window.innerHeight && !isMobile)
    ) {
      // document.querySelector('#rotate').classList.remove('active');
    } else {
      // document.querySelector('#rotate').classList.add('active');
    }
    // Updating renderer size and pixel ratio
    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(
      Math.min(Math.max(2, window.devicePixelRatio), isMobile ? 1.75 : 2.5)
    );
  }

  // Update method to render the scene and dispatch update events
  update(now, delta) {
    // if (!Global.isGameActive) return;

    // if (isMobile) {
    //   this.lastRendered = !this.lastRendered;
    // }

    // if (!this.lastRendered) this.renderer.render(this, this.camera);
    this.renderer.render(this, this.camera);
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'update',
        data: {
          delta: delta,
          camera: this.camera,
          now: now,
        },
      },
    });
  }

  // tick(now) {
  //   // 1. **Immediate Next Frame Request** (Always call first)
  //   window.requestAnimationFrame(this.tick.bind(this));

  //   // --- FPS LOCK LOGIC (Only runs on mobile/when needed) ---
  //   // Calculate time elapsed since the LAST successful render
  //   const elapsedTime = now - lastRenderTime;

  //   // Check if enough time (~16.67ms) has passed for a 60 FPS frame
  //   if (elapsedTime < TARGET_FRAME_INTERVAL) {
  //     // Not enough time has passed. Skip the logic and rendering this frame.
  //     return;
  //   }

  //   // Record the time of this successful render.
  //   // Subtracting the remainder keeps the timing accurate over many frames.
  //   lastRenderTime = now - (elapsedTime % TARGET_FRAME_INTERVAL);

  //   // -----------------------------------------------------------

  //   // 2. **Performance Monitoring**
  //   this.stats && this.stats.begin();
  //   this.controls && this.controls.update();

  //   // 3. **Time Calculation**
  //   // The delta is now based on the actual elapsed time between the last two renders
  //   const delta = (now - lastTime) / 1000; // Delta in seconds
  //   lastTime = now;

  //   // 4. **FPS Tracking (Optional, but useful)**
  //   // Your original FPS tracking logic remains, helping to determine true performance.
  //   frameCount++;
  //   if (delta) {
  //     fps = frameCount / delta;
  //     frameCount = 0;
  //   }

  //   // 5. **Global.delta Adjustment**
  //   // You must use the freshly calculated 'delta' (which now represents the time for a 60 FPS frame)
  //   // Your existing complex smoothing logic:
  //   const newDelta = Math.min(
  //     (delta ? Math.min(delta * 100, 1) : 1) * (120 / (fps || 1)),
  //     10
  //   );
  //   // This value is smoothed:

  //   // 6. **Physics Time Step**
  //   const scaledDelta = delta * this.physicsTimeScale;

  //   Global.delta = this.clock.getDelta() * 100; //scaledDelta * 50; //THREE.MathUtils.lerp(Global.delta, scaledDelta, 0.003); //this.clock.getDelta() * 100; //

  //   // 7. **Game Update and Render**
  //   // Note: You are passing lastDeltaVec.y here, which seems incorrect unless you intended to use a fixed value.
  //   // It should probably be 'scaledDelta' or 'delta'. I will preserve your original call but point it out.
  //   this.update(now, 0);
  //   // NOTE: Consider changing 'lastDeltaVec.y' in the line above to 'scaledDelta'

  //   // 8. **Performance Monitoring End**
  //   this.stats && this.stats.end();

  //   // The requestAnimationFrame call was moved to the very top.
  // }
  tick(now) {
    if (!this.canRender) {
      window.requestAnimationFrame(this.tick.bind(this));
      return;
    }
    Global.carInspectIndex++;
    if (Global.carInspectIndex > Global.carsTotal) {
      Global.carInspectIndex = 1;
    }
    this.stats && this.stats.begin();

    this.controls && this.controls.update();

    const delta = (now - lastTime) / 1000; // Convert milliseconds to seconds
    lastTime = now;

    frameCount++;
    if (delta) {
      fps = frameCount / delta;
      frameCount = 0;
    } else {
    }

    const newDelta = Math.min(
      (delta ? Math.min(delta * 100, 1) : 1) * (120 / (fps || 1)),
      10
    );

    const rawDelta = this.clock.getDelta() * 100;

    // if (Global.delta === 0 || Math.abs(Global.delta - rawDelta) > 0.5) {
    //   Global.delta = rawDelta;
    // } else {
    //   // 3. Apply Smoothing
    //   Global.delta = THREE.MathUtils.lerp(Global.delta, rawDelta, 0.1);
    // }
    Global.delta = rawDelta; //newDelta; //THREE.MathUtils.lerp(Global.delta, newDelta, 0.003); //this.clock.getDelta() * 100; //
    const scaledDelta = delta * this.physicsTimeScale;
    this.update(now, lastDeltaVec.y);

    this.stats && this.stats.end();
    window.requestAnimationFrame(this.tick.bind(this));
  }
  dispose() {
    document.querySelector('#game_view').classList.remove('active');
    document.querySelector('#game_view').classList.remove('active2');
  }
}

window.onload = async function () {
  checkDevice();

  const game = new Game();
  game.init();
};

function setUID(v) {
  Global.U_ID = JSON.parse(v)['UID'];
  Global.gameKey = JSON.parse(v)['gamekey'];

  Global.serverObj.setDetails(Global.U_ID, Global.gameKey);
}

function checkDevice() {
  // document.querySelector('#comingsoon').classList.add('active');
  if (!isMobile && window.innerWidth > window.innerHeight) {
    document.querySelector('.main').classList.add('desktop');
    document.querySelector('#soundBtn').classList.add('desktop');
    // document.querySelector('.continue_scr').classList.add('desktop');
    // document.querySelector('#game_header').classList.add('desktop');
    // document.querySelector('#rotate').classList.add('desktop');
    // document.querySelector('#age_screen').classList.add('desktop');
    // document.querySelector('#not_eligible').classList.add('desktop');
    // document.querySelector('#register_screen').classList.add('desktop');
    // document.querySelector('#avatar_screen').classList.add('desktop');
    // document.querySelector('#score_screen').classList.add('desktop');
    // document.querySelector('#leaderboard').classList.add('desktop');
  }
}
